import { LoaderIcon, ChevronRightIcon, ChevronDownIcon } from "~/icons";
import { Box } from "../Box/Box";

interface InlineFieldButtonProps {
  title?: string;
  children: string | React.ReactNode;
  disabled?: boolean;
  pressed?: boolean;
  onPress: () => void;
  padding?: "3";
  direction?: "right" | "down";
  noIcon?: boolean;
}

export function InlineFieldButton(
  props: InlineFieldButtonProps,
): React.ReactElement {
  const direction = props.direction || "right";

  return (
    <Box
      component="button"
      alignItems="center"
      borderRadius="standard"
      cursor="pointer"
      display="flex"
      padding={props.padding}
      position="relative"
      width="full"
      border="standard"
      borderColor={props.pressed ? "primary" : "neutral-400"}
      flexDirection={"row"}
      background="white"
      onClick={() => {
        if (props.pressed) return;
        props.onPress();
      }}
    >
      <Box
        width="full"
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"flexStart"}
        style={{ minWidth: 0 }}
      >
        {/* {Boolean(props.title) && <Text size="large">{props.title}</Text>} */}
        {props.children}
      </Box>
      {/* NOTE: loader icon and chevron have slight position adjustments,
       due to their inconsistent sizing and padding */}
      {!props.noIcon && (
        <Box
          display={"flex"}
          flexDirection={"row"}
          // justifyContent={"center"}
          alignItems={"flexEnd"}
          // style={{ border: "1px solid pink" }}
          height="full"
        >
          {props.pressed ? (
            <Box position={"relative"}>
              <LoaderIcon />
            </Box>
          ) : (
            // opacity hack makes the black icon look gray
            <Box position={"relative"} style={{ bottom: -2, opacity: 0.2 }}>
              {direction === "right" && <ChevronRightIcon fontSize={"22"} />}
              {direction === "down" && <ChevronDownIcon />}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
